import { SELF_SERVE_BRAND_INSTANT_ANSWERS_241209 } from "@faire/web-api--source/indigofair/settings/SELF_SERVE_BRAND_INSTANT_ANSWERS_241209";

import { useAssignSetting, useSetting } from "./useSetting";

export const useSettingSelfServeBrandInstantAnswers = (): boolean =>
  useSetting(SELF_SERVE_BRAND_INSTANT_ANSWERS_241209, false);

export const useAssignSettingSelfServeBrandInstantAnswers = () =>
  useAssignSetting(SELF_SERVE_BRAND_INSTANT_ANSWERS_241209);
